// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:992px){.pet-header-text[data-v-7ebb6b42]{font-size:2rem!important}}", ""]);
// Exports
module.exports = exports;
